import Vue from 'vue'
import Router from 'vue-router'
import shop_index from '@/components/shop_index'
import user_completeInfo from '@/components/user_completeInfo'
import user_index from '@/components/user_index'
import bus_completeInfo from '@/components/bus_completeInfo'
import bus_index from '@/components/bus_index'
import sort_index from '@/components/sort_index'
import link_index from '@/components/link_index'
import weiyuan_index from '@/components/weiyuan_index'
import search_index from '@/components/search_index'
import article_detail from '@/components/article_detail'
import article_preview from '@/components/article_preview'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
    	path: '/index',
    	name: 'shop_index',
    	component: shop_index,
    },
    {
      path: '/user_completeInfo',
      name: 'user_completeInfo',
      component: user_completeInfo,
    },
    {
      path: '/bus_completeInfo',
      name: 'bus_completeInfo',
      component: bus_completeInfo,
    },
    {
      path: '/bus_index',
      name: 'bus_index',
      component: bus_index,
    },
    {
      path: '/user_index',
      name: 'user_index',
      component: user_index,
    },
    {
      path: '/sort_index',
      name: 'sort_index',
      component: sort_index,
    },
    {
      path: '/weiyuan_index',
      name: 'weiyuan_index',
      component: weiyuan_index,
    },
    {
      path: '/link_index',
      name: 'link_index',
      component: link_index,
    },
    {
      path: '/search_index',
      name: 'search_index',
      component: search_index,
    },
    {
      path: '/article_detail',
      name: 'article_detail',
      component: article_detail,
    },
    {
      path: '/article_preview',
      name: 'article_preview',
      component: article_preview,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js